<template>
  <transition
    :name="transitionName"
    appear
    @before-enter="onBeforeEnter"
    @before-leave="onBeforeLeave"
  >
    <div class="faq-item" @click="goToDetail(faqItem.ID)">
      <p class="title">
        <span class="title-cont"> {{ faqItem.TITLE }}</span>
      </p>
    </div>
  </transition>
</template>

<script>
import {
  clickButton,
  locationType
} from '@plugins/biPoint/_configOfficialSupport';
export default {
  name: 'FaqItem',
  props: {
    // 工单数据项
    faqItem: {
      type: Object,
      required: true
    },
    // 工单索引
    index: {
      type: Number,
      required: true
    },
    // 控制操作按钮是否显示
    visibleControl: {
      type: Boolean,
      default: false
    },
    // 动画延迟时间
    transitionDelay: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      transitionName: 'slide-up',
      delayAni: 0
    };
  },
  created() {
    this.delayAni = this.transitionDelay;
  },
  methods: {
    onBeforeEnter(el) {
      el.setAttribute('style', `transition-delay: ${this.delayAni}s`);
    },
    onBeforeLeave(el) {
      el.setAttribute('style', `transition-delay: 0`);
    },
    goToDetail(faqId) {
      clickButton({
        btnName: 'goFaqDetail',
        locationKey: locationType.searchPage,
        otherParams: {
          faqId
        }
      });
      this.$router.push({
        name: 'workfaqdetail',
        query: {
          faqId
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.faq-item {
  overflow: hidden;
  position: relative;
  box-sizing: border-box;
  margin: 0 auto 18px;
  width: 100%;
  padding: 15px 13px;
  border-radius: 6px;
  background-color: var(--block-bg-light-color);
  box-shadow: 0px 3px 10px 0px rgba(51, 51, 51, 0.1);
  cursor: pointer;
  .title {
    display: flex;
    justify-content: space-between;
    align-content: center;
    line-height: 20px;
    &-cont {
      display: inline-block;
      width: 100%;
      font-size: 15px;

      font-weight: 500;
    }
    &-date {
      font-size: 12px;
      color: var(--placeholder-color);
    }
  }
}
</style>
